/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_OkInputs */

const en_mk_tut_agen_ok = /** @type {(inputs: Mk_Tut_Agen_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is one new comment from the agent, the status has moved to In review, and the transcript opens.`)
};

const id_mk_tut_agen_ok = /** @type {(inputs: Mk_Tut_Agen_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada satu komentar baru dari agen, status pindah ke Perlu review, dan transkripnya bisa dibuka.`)
};

/**
* | output |
* | --- |
* | "There is one new comment from the agent, the status has moved to In review, and the transcript opens." |
*
* @param {Mk_Tut_Agen_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_ok = /** @type {((inputs?: Mk_Tut_Agen_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_ok(inputs)
	return en_mk_tut_agen_ok(inputs)
});